import React from 'react';
import {
    MdDashboard,
    MdPeople,
    MdSyncAlt,
    MdStore,
    MdInventory,
    MdDescription,
    MdCampaign,
    MdPointOfSale,
    MdSettings,
    MdLogout,
    MdBuild,
    MdLocalOffer,
    MdPriceCheck,
    MdTrendingUp,
    MdUpload,
    MdViewList,
    MdPerson,
    MdBadge,
    MdStorefront,
    MdLocalShipping,
    MdPublic,
    MdLocationOn,
    MdTimeline,
    MdVerifiedUser,
    MdAssignment,
    MdHub,
    MdFileUpload,
    MdVerified,
    MdBusiness, // Distributor specific
    MdReceiptLong, // Distributor specific
    MdCloudUpload, // Distributor specific
    MdCardGiftcard,
    MdTune, // Admin specific
    MdAccountTree, // Admin specific
    MdPendingActions, // Approvals
    MdFactCheck, // Bill approvals
    MdNotifications,
    MdHistory,
    MdUpdate,
    MdLocationCity,
    MdCloudQueue,
    MdHowToReg,
    MdWorkspacePremium,
    MdCloudSync,
    MdInsights, // Statistika prikaza
    MdExtension,
} from 'react-icons/md';

export const partnerNavigationItems = [
    { path: '/', labelKey: 'PartnerNavigation.dashboard', icon: <MdDashboard className="icon" /> },
    { path: '/retailers', labelKey: 'PartnerNavigation.retailers', icon: <MdStorefront className="icon" /> },
    { path: '/users', labelKey: 'PartnerNavigation.team', icon: <MdPeople className="icon" /> },
    { path: '/installations', labelKey: 'PartnerNavigation.installations', icon: <MdExtension className="icon" /> },
    { path: '/commissions', labelKey: 'PartnerNavigation.commissions', icon: <MdTrendingUp className="icon" /> },
    { path: '/settings', labelKey: 'PartnerNavigation.settings', icon: <MdSettings className="icon" /> },
];

// Retailer / Organization Items
export const navigationItems = [
    {
        path: '/',
        labelKey: 'Navigation.dashboard',
        icon: <MdDashboard className="icon" />,
    },
    {
        path: '/best-offers',
        labelKey: 'Navigation.bestOffers',
        icon: <MdLocalOffer className="icon" />,
    },
    {
        path: '/distributors',
        labelKey: 'Navigation.distributors',
        icon: <MdLocalShipping className="icon" />,
    },
    {
        path: '/users',
        labelKey: 'Navigation.users',
        icon: <MdBadge className="icon" />,
    },
    {
        path: '/customers',
        labelKey: 'Navigation.customers',
        icon: <MdPeople className="icon" />,
    },
    {
        path: '/transactions',
        labelKey: 'Navigation.transactions',
        icon: <MdSyncAlt className="icon" />,
    },
    {
        path: '/cross-sell-earnings',
        labelKey: 'Navigation.crossSellEarnings',
        icon: <MdTrendingUp className="icon" />,
    },
    {
        path: '/venues',
        labelKey: 'Navigation.venues',
        icon: <MdStore className="icon" />,
    },
    {
        path: '/campaigns',
        labelKey: 'Navigation.campaigns',
        icon: <MdCampaign className="icon" />,
    },
    {
        path: '/items',
        labelKey: 'Navigation.items',
        icon: <MdInventory className="icon" />,
    },
    {
        path: '/products',
        labelKey: 'Navigation.products',
        icon: <MdViewList className="icon" />,
    },
    {
        path: '/scanned-bills',
        labelKey: 'Navigation.scannedBills',
        icon: <MdReceiptLong className="icon" />,
    },
    {
        path: '/bill-approvals',
        labelKey: 'Navigation.billApprovals',
        icon: <MdFactCheck className="icon" />,
    },
    {
        path: '/discounts',
        labelKey: 'Navigation.discounts',
        icon: <MdPriceCheck className="icon" />,
    },
    {
        path: '/discovery-stats',
        labelKey: 'Navigation.discoveryStats',
        icon: <MdInsights className="icon" />,
    },
    {
        path: '/delivery',
        labelKey: 'Navigation.delivery',
        icon: <MdPublic className="icon" />,
    },
    {
        path: '/warranties',
        labelKey: 'Navigation.warranties',
        icon: <MdDescription className="icon" />,
    },
    {
        path: '/repair-services',
        labelKey: 'Navigation.repairServices',
        icon: <MdBuild className="icon" />,
    },
    {
        path: '/integration',
        labelKey: 'Navigation.pos_integration',
        icon: <MdPointOfSale className="icon" />,
    },
    {
        path: '/catalog-import',
        labelKey: 'CatalogWorkspace.title',
        icon: <MdUpload className="icon" />,
    },
    {
        path: '/plan',
        labelKey: 'Navigation.plan',
        icon: <MdWorkspacePremium className="icon" />,
    },
    {
        path: '/partner-referral',
        labelKey: 'Navigation.partnerReferral',
        icon: <MdHub className="icon" />,
    },
    {
        path: '/settings',
        labelKey: 'Navigation.settings',
        icon: <MdSettings className="icon" />,
    },
    {
        path: '/profile',
        labelKey: 'Navigation.profile',
        icon: <MdPerson className="icon" />,
    },
];

// Manufacturer Items
// Note: Some icons were implicit or imported differently, standardized here.
export const manufacturerNavigationItems = [
    {
        path: '/',
        labelKey: 'ManufacturerNav.dashboard',
        icon: <MdDashboard className="icon" />,
    },
    {
        path: '/products',
        labelKey: 'ManufacturerNav.products',
        icon: <MdInventory className="icon" />,
    },
    {
        path: '/product-approvals',
        labelKey: 'ManufacturerNav.productApprovals',
        icon: <MdPendingActions className="icon" />,
    },
    {
        path: '/discounts',
        labelKey: 'ManufacturerNav.discounts',
        icon: <MdPriceCheck className="icon" />,
    },
    {
        path: '/retailers',
        labelKey: 'ManufacturerNav.retailers',
        icon: <MdStorefront className="icon" />,
    },
    {
        path: '/distributors',
        labelKey: 'ManufacturerNav.distributors',
        icon: <MdLocalShipping className="icon" />,
    },
    {
        path: '/venues',
        labelKey: 'ManufacturerNav.venues',
        icon: <MdLocationOn className="icon" />,
    },
    {
        path: '/transactions',
        labelKey: 'ManufacturerNav.transactions',
        icon: <MdTimeline className="icon" />,
    },
    {
        path: '/warranties',
        labelKey: 'ManufacturerNav.warranties',
        icon: <MdVerifiedUser className="icon" />,
    },
    {
        path: '/support',
        labelKey: 'ManufacturerNav.support',
        icon: <MdAssignment className="icon" />,
    },
    {
        path: '/integrations',
        labelKey: 'ManufacturerNav.integrations',
        icon: <MdHub className="icon" />,
    },
    {
        path: '/imports',
        labelKey: 'ManufacturerNav.imports',
        icon: <MdFileUpload className="icon" />,
    },
    {
        path: '/compliance',
        labelKey: 'ManufacturerNav.compliance',
        icon: <MdVerified className="icon" />,
    },
    {
        path: '/settings',
        labelKey: 'ManufacturerNav.settings',
        icon: <MdSettings className="icon" />,
    },
];

// Distributor Items
export const distributorNavigationItems = [
    {
        path: '/',
        labelKey: 'DistributorNav.dashboard',
        icon: <MdDashboard className="icon" />,
    },
    {
        path: '/best-offers',
        labelKey: 'DistributorNav.bestOffers',
        icon: <MdLocalOffer className="icon" />,
    },
    {
        path: '/manufacturers',
        labelKey: 'DistributorNav.manufacturers',
        icon: <MdBusiness className="icon" />,
    },
    {
        path: '/discounts',
        labelKey: 'DistributorNav.discounts',
        icon: <MdPriceCheck className="icon" />,
    },
    {
        path: '/retailers',
        labelKey: 'DistributorNav.retailers',
        icon: <MdStorefront className="icon" />,
    },
    {
        path: '/venues',
        labelKey: 'DistributorNav.venues',
        icon: <MdLocationOn className="icon" />,
    },
    {
        path: '/transactions',
        labelKey: 'DistributorNav.transactions',
        icon: <MdReceiptLong className="icon" />,
    },
    {
        path: '/integrations',
        labelKey: 'DistributorNav.integrations',
        icon: <MdHub className="icon" />,
    },
    {
        path: '/imports',
        labelKey: 'DistributorNav.imports',
        icon: <MdCloudUpload className="icon" />,
    },
    {
        path: '/settings',
        labelKey: 'DistributorNav.settings',
        icon: <MdSettings className="icon" />,
    },
];

// Admin Items
export const adminNavigationItems = [
    {
        path: '/',
        labelKey: 'AdminNav.dashboard', // Or just 'Dashboard' if keys aren't ready
        icon: <MdDashboard className="icon" />,
    },
    {
        path: '/users',
        labelKey: 'AdminNav.users',
        icon: <MdPeople className="icon" />,
    },
    {
        path: '/organizations',
        labelKey: 'AdminNav.organizations',
        icon: <MdBusiness className="icon" />,
    },
    {
        path: '/organization-approvals',
        labelKey: 'AdminNav.organizationApprovals',
        icon: <MdHowToReg className="icon" />,
    },
    {
        path: '/customers',
        labelKey: 'AdminNav.customers',
        icon: <MdPeople className="icon" />,
    },
    {
        path: '/venues',
        labelKey: 'AdminNav.venues',
        icon: <MdLocationOn className="icon" />,
    },
    {
        path: '/cities',
        labelKey: 'AdminNav.cities',
        icon: <MdLocationCity className="icon" />,
    },
    {
        path: '/scanned-bills',
        labelKey: 'AdminNav.scannedBills',
        icon: <MdReceiptLong className="icon" />,
    },
    {
        path: '/scraper-staging',
        labelKey: 'AdminNav.scraperStaging',
        icon: <MdCloudQueue className="icon" />,
    },
    {
        path: '/catalog-operations',
        labelKey: 'AdminNav.catalogOperations',
        icon: <MdCloudSync className="icon" />,
    },
    {
        path: '/promotions/types',
        labelKey: 'AdminNav.promotionTypes',
        icon: <MdTune className="icon" />,
    },
    {
        path: '/categories/mapping',
        labelKey: 'AdminNav.categoryMapping',
        icon: <MdAccountTree className="icon" />,
    },
    {
        path: '/alerts',
        labelKey: 'AdminNav.alerts',
        icon: <MdNotifications className="icon" />,
    },
    {
        path: '/notifications',
        labelKey: 'AdminNav.notifications',
        icon: <MdNotifications className="icon" />,
    },
    {
        path: '/notification-logs',
        labelKey: 'AdminNav.notificationLogs',
        icon: <MdHistory className="icon" />,
    },
    {
        path: '/giveaways',
        labelKey: 'AdminNav.giveaways',
        icon: <MdCardGiftcard className="icon" />,
    },
    {
        path: '/global-points-settings',
        labelKey: 'AdminNav.globalPointsSettings',
        icon: <MdTune className="icon" />,
    },
    {
        path: '/freshness',
        labelKey: 'AdminNav.freshness',
        icon: <MdUpdate className="icon" />,
    },
    {
        path: '/transactions',
        labelKey: 'AdminNav.transactions',
        icon: <MdSyncAlt className="icon" />,
    },
    {
        path: '/revenue',
        labelKey: 'AdminNav.revenue',
        icon: <MdTrendingUp className="icon" />,
    },
    {
        path: '/billing/profiles',
        labelKey: 'AdminNav.billingProfiles',
        icon: <MdPointOfSale className="icon" />,
    },
    {
        path: '/plan-offers',
        labelKey: 'AdminNav.planOffers',
        icon: <MdPriceCheck className="icon" />,
    },
    {
        path: '/billing/bills',
        labelKey: 'AdminNav.bills',
        icon: <MdReceiptLong className="icon" />,
    },
    {
        path: '/billing/invoices',
        labelKey: 'AdminNav.invoices',
        icon: <MdDescription className="icon" />,
    },
    {
        path: '/contracts',
        labelKey: 'AdminNav.contracts',
        icon: <MdBadge className="icon" />,
    },
    {
        path: '/revenue/reconciliation',
        labelKey: 'AdminNav.reconciliation',
        icon: <MdFactCheck className="icon" />,
    },
    {
        path: '/integrations',
        labelKey: 'AdminNav.integrations',
        icon: <MdHub className="icon" />,
    },
    {
        path: '/integrations/logs',
        labelKey: 'AdminNav.integrationLogs',
        icon: <MdTimeline className="icon" />,
    },
    {
        path: '/integrations/sync',
        labelKey: 'AdminNav.integrationSync',
        icon: <MdSyncAlt className="icon" />,
    },
    {
        path: '/integrations/quotas',
        labelKey: 'AdminNav.integrationQuotas',
        icon: <MdTune className="icon" />,
    },
];

export const adminNavigationSections = [
    {
        id: 'overview',
        labelKey: 'AdminNavGroups.overview',
        items: [
            adminNavigationItems.find((item) => item.path === '/'),
        ].filter(Boolean),
    },
    {
        id: 'identity',
        labelKey: 'AdminNavGroups.identity',
        items: [
            adminNavigationItems.find((item) => item.path === '/users'),
            adminNavigationItems.find((item) => item.path === '/organizations'),
            adminNavigationItems.find((item) => item.path === '/organization-approvals'),
            adminNavigationItems.find((item) => item.path === '/customers'),
            adminNavigationItems.find((item) => item.path === '/venues'),
            adminNavigationItems.find((item) => item.path === '/cities'),
        ].filter(Boolean),
    },
    {
        id: 'operations',
        labelKey: 'AdminNavGroups.operations',
        items: [
            adminNavigationItems.find((item) => item.path === '/transactions'),
            adminNavigationItems.find((item) => item.path === '/revenue'),
            adminNavigationItems.find((item) => item.path === '/revenue/reconciliation'),
            adminNavigationItems.find((item) => item.path === '/billing/profiles'),
            adminNavigationItems.find((item) => item.path === '/plan-offers'),
            adminNavigationItems.find((item) => item.path === '/billing/bills'),
            adminNavigationItems.find((item) => item.path === '/billing/invoices'),
            adminNavigationItems.find((item) => item.path === '/contracts'),
            adminNavigationItems.find((item) => item.path === '/integrations'),
            adminNavigationItems.find((item) => item.path === '/integrations/logs'),
            adminNavigationItems.find((item) => item.path === '/integrations/sync'),
            adminNavigationItems.find((item) => item.path === '/integrations/quotas'),
            adminNavigationItems.find((item) => item.path === '/scanned-bills'),
            adminNavigationItems.find((item) => item.path === '/scraper-staging'),
            adminNavigationItems.find((item) => item.path === '/catalog-operations'),
            adminNavigationItems.find((item) => item.path === '/alerts'),
            adminNavigationItems.find((item) => item.path === '/notifications'),
            adminNavigationItems.find((item) => item.path === '/notification-logs'),
            adminNavigationItems.find((item) => item.path === '/giveaways'),
            adminNavigationItems.find((item) => item.path === '/global-points-settings'),
            adminNavigationItems.find((item) => item.path === '/freshness'),
        ].filter(Boolean),
    },
    {
        id: 'cms',
        labelKey: 'AdminNavGroups.cmsRules',
        items: [
            adminNavigationItems.find((item) => item.path === '/promotions/types'),
            adminNavigationItems.find((item) => item.path === '/categories/mapping'),
        ].filter(Boolean),
    },
];


export const logoutItem = {
    labelKey: 'Navigation.logout',
    icon: <MdLogout className="icon" />,
};

// Helper to find icon by path
export const getIconForPath = (currentPath) => {
    // Search in all lists
    const allItems = [
        ...navigationItems,
        ...manufacturerNavigationItems,
        ...distributorNavigationItems,
        ...adminNavigationItems,
        ...adminNavigationSections.flatMap(section => section.items || []),
    ].filter(Boolean);

    // Exact match
    const exact = allItems.find(item => item.path === currentPath);
    if (exact) return exact.icon;

    // Prefix match (for sub-routes), sorting by length to match most specific first
    // Excluding root '/' to avoid matching everything
    const match = allItems
        .filter(item => item.path !== '/')
        .sort((a, b) => b.path.length - a.path.length)
        .find(item => currentPath.startsWith(item.path));

    return match ? match.icon : null;
};
